/* eslint object-curly-spacing: 'off' */
export default {
    get: function () {
        const publicPages = [r1, r2, r3, r4, r5, r6, r7, r8, r9, r10, r11];
        const other = [];

        return {
            public: {
                name: 'relatedInformation',
                menu: publicPages,
                other
            }
        }
    }
}

const r1 = { name: 'r1', isExternal: true, url: 'https://www.cdc.gov/brfss/brfssprevalence/index.html', title: 'Prevalence and Trends Data', groupName: 'relatedInformation' };
const r2 = { name: 'r2', isExternal: true, url: 'https://www.cdc.gov/brfss/questionnaires/index.htm', title: 'Historical Questions', groupName: 'relatedInformation' };
const r3 = { name: 'r3', isExternal: true, url: 'https://www.cdc.gov/brfss/about/index.htm', title: 'About the BRFSS', groupName: 'relatedInformation' };
const r4 = { name: 'r4', isExternal: true, url: 'https://www.cdc.gov/brfss/about/brfss_faq.htm', title: 'FAQs', groupName: 'relatedInformation' };
const r5 = { name: 'r5', isExternal: true, url: 'https://www.cdc.gov/brfss/questionnaires.htm', title: 'Questionnaires', groupName: 'relatedInformation' };
const r6 = { name: 'r6', isExternal: true, url: 'https://www.cdc.gov/brfss/state_info/index.htm', title: 'State Information', groupName: 'relatedInformation' };
const r7 = { name: 'r7', isExternal: true, url: 'https://www.cdc.gov/brfss/annual_data/annual_data.htm', title: 'Technical Info and Data', groupName: 'relatedInformation' };
const r8 = { name: 'r8', isExternal: true, url: 'https://www.cdc.gov/chronicdisease/resources/publications/aag/brfss.htm', title: 'Training', groupName: 'relatedInformation' };
const r9 = { name: 'r9', isExternal: true, url: 'https://www.cdc.gov/brfss/data_documentation/statistic_brief.htm', title: 'Statistical Briefs', groupName: 'relatedInformation' };
const r10 = { name: 'r10', isExternal: true, url: 'https://www.cdc.gov/chronicdisease/stats/', title: 'Related Links', groupName: 'relatedInformation' };
const r11 = { name: 'r11', isExternal: true, url: 'https://www.cdc.gov/brfss/', title: 'BRFSS Home', groupName: 'relatedInformation' };
